import { Button, IconButton } from "@mui/material";
import { Copy } from "lucide-react";
import React, { CSSProperties, useState } from "react";
import SnackPack, { SnackbarMessage } from "./SnackPack";

export default ({
  value,
  onReveal,
  disabled = false,
  variant,
  label = "copy",
  showIcon = true,
  sx,
}: {
  value?: string;
  onReveal?: () => Promise<string>;
  disabled?: boolean;
  variant?: "text" | "icon";
  label?: string;
  showIcon?: boolean;
  sx?: CSSProperties;
}) => {
  const [snackPack, setSnackPack] = useState<readonly SnackbarMessage[]>([]);
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    if (onReveal) {
      setLoading(true);
      try {
        const valueToUse = await onReveal();
        setSnackPack([{ key: valueToUse, message: "Copied to clipboard" }]);
        navigator.clipboard.writeText(valueToUse);
      } catch (error) {
        console.error("Failed to copy:", error);
      } finally {
        setLoading(false);
      }
    } else if (value) {
      setSnackPack([{ key: value, message: "Copied to clipboard" }]);
      navigator.clipboard.writeText(value);
    }
  };

  return (
    <>
      {variant == "text" ? (
        <Button
          variant="text"
          size="small"
          onClick={handleClick}
          disabled={disabled || loading}
          startIcon={showIcon ? <Copy size={20} /> : undefined}
          sx={sx}
        >
          {label}
        </Button>
      ) : (
        <IconButton
          onClick={handleClick}
          disabled={disabled || loading}
          sx={sx}
        >
          <Copy size={20} />
        </IconButton>
      )}

      <SnackPack
        snackPack={snackPack}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      />
    </>
  );
};
